import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
// GeneralViews
import NotFound from "@/pages/NotFoundPage.vue";

// Bdeole pages
import ParcList from "@/pages/ParcList.vue";
import ParcProfile from "@/pages/ParcProfile.vue";
import ProfileChoice from "@/pages/ProfileChoice.vue";

const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/parc-list",
    children: [
      {
        path: "profile-choice",
        name: "profile-choice",
        component: ProfileChoice
      },
      {
        path: "parc-list",
        name: "parc-list",
        component: ParcList
      },
      {
        path: "parc-profile",
        name: "parc-profile",
        component: ParcProfile
      }
    ]
  },
  { path: '/:pathMatch(.*)*', name: 'not-found', component: NotFound },
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
